// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"179":"main","350":"swagger-ui"}[chunkId] || chunkId) + ".css";
};